import React from 'react';
import { FindFavoriteProvider } from '../favorites/find_favorite_context';
import { UpdateURLProvider, UpdateUrlType } from '@reverbdotcom/commons/src/components/with_update_url';
import { ExperimentProvider } from '../../context/ExperimentContext';
import { useEppoExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import eppoFlags from '@reverbdotcom/commons/src/eppoFlags';

export interface Props {
  updateUrl: UpdateUrlType;
  children: React.ReactNode;

  // Used to force a rerender and refetch of find favorite data
  // if the marketplace page layout changes
  keySuffix: string;
}

export function MarketplaceProviders(props: Props) {
  return (
    <FindFavoriteProvider key={`find-favorite-provider--${props.keySuffix}`}>
      <UpdateURLProvider updateUrl={props.updateUrl}>
        <ExperimentProvider
          values={{
            isBumpDisplayExpEnabled: useEppoExpEnabled({ flagKey: eppoFlags.LISTING_BUMP_DISPLAY }),
            isPriceRecExpEnabled: useEppoExpEnabled({ flagKey: eppoFlags.GREAT_VALUE_EU_MARKETPLACE }),
            isRemoveReturnPolicyNudgeExpEnabled: useEppoExpEnabled({ flagKey: eppoFlags.WEB_MARKETPLACE_REMOVE_RETURN_POLICY_BADGES }),
          }}
        >
          {props.children}
        </ExperimentProvider>
      </UpdateURLProvider>
    </FindFavoriteProvider>
  );
}
